/* TR1 Cells LP — tier selector + one-time link. Vanilla, no deps. */
(function(){
  if (window.__tr1Cells) return; window.__tr1Cells = true;
  function init(root){
    var form = root.querySelector('[data-tr1-form]'); if(!form) return;
    var idIn = form.querySelector('[data-tr1-id]'), planIn = form.querySelector('[data-tr1-plan]');
    var tiers = form.querySelectorAll('.tier');
    tiers.forEach(function(t){
      t.addEventListener('click', function(){
        tiers.forEach(function(x){ x.classList.remove('on'); });
        t.classList.add('on');
        var r = t.querySelector('input[type=radio]'); if (r) r.checked = true;
        idIn.value = t.getAttribute('data-variant');
        planIn.value = t.getAttribute('data-plan') || '';
        planIn.disabled = !planIn.value;
      });
    });
    planIn.disabled = !planIn.value;
    var ot = form.querySelector('[data-tr1-onetime]');
    if (ot) ot.addEventListener('click', function(){
      idIn.value = ot.getAttribute('data-variant');
      planIn.value = ''; planIn.disabled = true;
    });
  }
  function boot(){ document.querySelectorAll('[data-tr1-buy]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
